module.exports = __webpack_public_path__ + "static/media/book_sjzn.b3360cbb.png";